<div class="variant-wrapper">
  <div class="group-card" *ngFor="let group of colorGroups">
    <div class="group-header" (click)="toggleGroup(group)">
      <div class="group-title">{{ group.color }}</div>
      <span class="group-arrow" [class.expanded]="group.expanded">⌄</span>
    </div>

    <div class="group-body" *ngIf="group.expanded && group.sizes.length > 0">
      <div class="sizes-grid header-row"
        [style.gridTemplateColumns]="'80px repeat(' + group.sizes.length + ', minmax(90px, 1fr))'">
        <div class="size-cell title-cell">Sizes</div>
        <div class="size-cell" *ngFor="let size of group.sizes">{{ size }}</div>
      </div>

      <div class="sizes-grid value-row"
        [style.gridTemplateColumns]="'80px repeat(' + group.sizes.length + ', minmax(90px, 1fr))'">
        <div class="size-cell title-cell"></div>

        <div class="size-cell" *ngFor="let size of group.sizes">
          <ng-container *ngIf="getItem(group, size) as variant">
            <input type="number" min="0" class="qty-input" [value]="variant.SelectedQuantity"
              (input)="onQtyInput(variant, $any($event.target).value)" />
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <div class="total">Total Quantity: {{ totalQuantity() }}</div>
    <button nz-button nzType="primary" (click)="ok()">OK</button>
  </div>
</div>
